import React from 'react';
import { FiX, FiAlertCircle } from 'react-icons/fi';
import { Link } from '@tanstack/react-router';

interface StripeOnboardingPromptModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const StripeOnboardingPromptModal: React.FC<StripeOnboardingPromptModalProps> = ({
  isOpen,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center overflow-y-auto bg-black/70 px-4 py-6 backdrop-blur-sm">
      <div className="w-full max-w-md my-auto max-h-[90vh] overflow-y-auto rounded-3xl border border-[#2C2C2E] bg-[#1C1C1E] shadow-2xl">
        <div className="flex items-center justify-between border-b border-[#2C2C2E] px-4 sm:px-6 py-4">
          <h3 className="text-lg font-bold text-white">Stripe Onboarding Required</h3>
          <button
            onClick={onClose}
            className="rounded-full p-1.5 text-zinc-400 hover:bg-white/5 hover:text-white transition cursor-pointer"
          >
            <FiX size={18} />
          </button>
        </div>

        <div className="p-4 sm:p-6 text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-amber-500/10 text-amber-500">
            <FiAlertCircle size={32} />
          </div>

          <p className="mb-4 text-zinc-200 font-medium">
            Please complete your Stripe onboarding before creating an offer.
          </p>
          <p className="mb-6 text-sm text-zinc-400 leading-relaxed">
            To create and send structured gig offers, you must have a connected Stripe account. This
            allows recipients to pay securely using direct Stripe checkout links.
          </p>

          <div className="flex flex-col gap-3">
            <Link
              to="/profile/settings/payments"
              className="inline-flex w-full items-center justify-center rounded-full bg-[#1784FF] hover:bg-blue-600 px-5 py-3 text-sm font-semibold text-white shadow-lg transition cursor-pointer"
              onClick={onClose}
            >
              Go to Stripe Onboarding
            </Link>

            <button
              onClick={onClose}
              className="text-xs font-semibold text-zinc-500 hover:text-zinc-300 transition mt-2 cursor-pointer"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
